import status from "../constants/actionStatus";

export default (
    state = {
        selfLearningData: {},
        dataId: null,
        sectionId: null,
        contentId: null,
        quizResponse: {},
        unlockCertificate: {}
    },
    action = {}
) => {
    switch (action.type) {
    case "SELF_LEARNING_REQUEST":
        return {
            ...state,
            status: status.PENDING,
            selfLearningData: {},
        };
    case "SELF_LEARNING_SUCCESS":
        return {
            ...state,
            status: status.SUCCESS,
            selfLearningData: action.payload,
        };

    case "PRACTICE_QUIZ_ATTEMPTS_FAILURE":
        return {
            ...state,
            status: status.ERROR,
            selfLearningData: {},
        };
        case "PRACTICE_QUIZ_ATTEMPTS_REQUEST":
        return {
            ...state,
            status: status.PENDING,
            selfLearningData: {},
        };
    case "PRACTICE_QUIZ_ATTEMPTS_SUCCESS":
        return {
            ...state,
            status: status.SUCCESS,
            selfLearningData: action.payload,
        };

    case "SELF_LEARNING_FAILURE":
        return {
            ...state,
            status: status.ERROR,
            selfLearningData: {},
        };
    case "CLEAR_SELF_LEARNING":
        return { ...state, status: status.PENDING, selfLearningData: {} };
    case "SET_DATA_ID":
        return {
            ...state,
            dataId: action.payload,
        };
    case "SET_SECTION_ID":
        return {
            ...state,
            sectionId: action.payload,
        };
    case "SET_CONTENT_ID":
        return {
            ...state,
            contentId: action.payload,
        };
    case "SET_QUIZ_RESPONSE":
        return {
            ...state,
            quizResponse: action.payload,
        };
    case "SET_UNLOCK_CERTIFICATE":
        return {
            ...state,
            unlockCertificate: action.payload,
        };
    default:
        return state;
    }
};
